import request from '@/services/interceptor.js'


export const get_richieste = () => {
    return request({
        url: '/comunicazioni/richieste/',
        method: 'get',
        loadingBar: true
    })
};

export const send_comunicazione = (data) => {
    return request({
        url: '/comunicazioni/invia/',
        method: 'post',
        data: data,
        loadingBar: true
    })
};

export const subscribe = (data) => {
    return request({
        url: '/comunicazioni/subscribe/',
        method: 'post',
        data: data,
        loadingBar: true
    })
};
export const unsubscribe = (data) => {
    return request({
        url: '/comunicazioni/unsubscribe/',
        method: 'post',
        data: data,
        loadingBar: true
    })
};

export const send_test = () => {
    return request({
        url: '/comunicazioni/sendtest/',
        method: 'get',
        loadingBar: true
    })
};